module.exports = __webpack_public_path__ + "static/media/upload-error.0c0f676f.svg";